export type BrokerConnectedAccountRow = {
  accountCode: string;
  displayName: string;
  customName?: string | null;
  isDemo?: boolean;
};

export function formatBrokerConnectedAccountDisplayName(
  accountCode: string,
  customName?: string | null,
  fallbackLabel?: string | null
): string {
  const custom = customName?.trim();
  const code = accountCode.trim();
  if (custom) return `${custom} (${code})`;
  return fallbackLabel?.trim() || code;
}

export function brokerConnectedAccountConfirmLabel(account: BrokerConnectedAccountRow): string {
  return `${account.displayName}${account.isDemo ? " (Demo)" : ""}`;
}
